import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_TRUCK_LIST:
      return { ...action.truckList };
    case Action.REMOVE_TRUCK_LIST:
      return {};
    default:
      return state;
  }
};
